import { render, staticRenderFns } from "./SectionProjects.vue?vue&type=template&id=77f9c98c&"
import script from "./SectionProjects.vue?vue&type=script&lang=js&"
export * from "./SectionProjects.vue?vue&type=script&lang=js&"
import style0 from "./SectionProjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports